import {createRouter, createWebHistory} from 'vue-router'
import Catalog from "./Pages/Catalog";
import Group from "./Pages/Group";
import ProductCard from "./Pages/ProductCard";

const scrollBehavior = () => ({
    el: '#pubcatalog',
    top: -10,
})

const routes = [
    {
        path: '/catalog',
        name: 'catalog',
        component: Catalog,
        meta: {name: 'Каталог'}
    },
    {
        path: '/catalog/:group_slug',
        name: 'group',
        component: Group,
        children: [],
    },
    {
        path: '/catalog/:group_slug/:product_slug',
        name: 'product',
        component: ProductCard,
    },
    {
        path: '/catalog/product/:product_slug',
        name: 'product_card',
        component: ProductCard,
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior,
    routes,
})

export default router